import React from 'react';
import { Link } from 'react-router-dom';

const Button = ({
    children,
    to,
    href,
    variant = 'primary',
    onClick,
    type = 'button',
    style = {},
    className = '',
    ...props
}) => {
    const buttonClass = `btn btn-${variant} ${className}`;

    if (to) {
        return (
            <Link to={to} className={buttonClass} style={style} {...props}>
                {children}
            </Link>
        );
    }

    if (href) {
        return (
            <a href={href} className={buttonClass} style={style}>
                {children}
            </a>
        );
    }

    return (
        <button
            type={type}
            className={buttonClass}
            onClick={onClick}
            style={style}
        >
            {children}
        </button>
    );
};

export default Button;
